import { render, staticRenderFns } from "./OvertimeRequestFormDialog.vue?vue&type=template&id=35980c7f&"
import script from "./OvertimeRequestFormDialog.vue?vue&type=script&lang=ts&"
export * from "./OvertimeRequestFormDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports